(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rim-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('rim-finder')) return;

    const normalize = (value) => String(value ?? '').toLowerCase().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9.]+/g, ' ').trim();
    const colorGroups = {
      black: ['black', 'satin black', 'matte black', 'gloss black', 'hyper black', 'piano black', 'negro'],
      bronze: ['bronze', 'matte bronze', 'dark bronze', 'bronce'],
      silver: ['silver', 'machined silver', 'hyper silver', 'plata'],
      gunmetal: ['gunmetal', 'gun metal', 'graphite', 'grafito'],
      chrome: ['chrome', 'chromium', 'cromo'], polished: ['polished', 'polish', 'pulido'],
      white: ['white', 'blanco'], red: ['red', 'candy red', 'rojo'], gold: ['gold', 'dorado'], blue: ['blue', 'azul']
    };
    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    // Normalized bolt patterns: "5X114.3", "6X135/6X139.7" or "4x100/114.3" -> ["5x114.3", ...].
    const boltKeys = (value) => {
      const keys = new Set();
      let lugs = null;
      String(value ?? '').toLowerCase().replace(/×/g, 'x').split(/[/,|&]+/).forEach((part) => {
        const match = part.trim().match(/^(?:([0-9]{1,2}) ?x ?)?([0-9]{2,3}(?:[.][0-9]{1,2})?) ?(?:mm)?$/);
        if (!match) return;
        if (match[1]) lugs = Number(match[1]);
        const pcd = Number(match[2]);
        if (lugs >= 3 && lugs <= 10 && pcd >= 90 && pcd <= 220) keys.add(`${lugs}x${Math.round(pcd * 10) / 10}`);
      });
      return [...keys];
    };
    // Bolt patterns written in tags or titles, e.g. "18x8 5x114.3 ET40"; wheel sizes like 18x8 are rejected by range.
    const boltKeysInText = (text) => [...String(text ?? '').matchAll(/(?:^|[^0-9.])([0-9]{1,2}) ?[x×] ?([0-9]{2,3}(?:[.][0-9]{1,2})?)(?![0-9.])/gi)]
      .flatMap((match) => boltKeys(`${match[1]}x${match[2]}`));
    const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Card text rules, mirrored from blocks/rim-card-info.liquid (collection cards) so search results
    // read the same way. Keep both in step; .local-tools/test-rim-cards.cjs compares them across the
    // whole catalog. Display only: product titles themselves are never changed.
    const KEEP_UPPER = ['UTV', 'AMG', 'SUV', 'OEM', 'USA', 'AWD', 'ATV', 'EV', 'GTI', 'II', 'III', 'IV', 'VI', 'VII', 'VIII', 'IX', 'XI', 'XII', 'ES', 'IS', 'LS', 'LE', 'SE'];
    const hasDigit = (word) => /[0-9]/.test(word);
    const hasVowel = (word) => /[AEIOU]/.test(word);
    const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    const caseSegment = (word) => {
      if (hasDigit(word) || !hasVowel(word) || KEEP_UPPER.includes(word) || word.includes('.')) return word;
      if (word.includes('-')) return word.split('-').map((part) => (part.length >= 4 && !KEEP_UPPER.includes(part) && hasVowel(part) ? capitalize(part) : part)).join('-');
      return capitalize(word);
    };
    // 'RED/BLACK' is two words; 'W/' (as in 'machined w/ clear coat') keeps its slash.
    const caseWord = (word) => (word.includes('/') && !word.startsWith('/') && !word.endsWith('/') ? word.split('/').map(caseSegment).join('/') : caseSegment(word));
    // Only ALL-CAPS supplier text is softened; mixed case was typed deliberately.
    const titleCase = (text) => (text !== text.toUpperCase() ? text : text.trim().split(/\s+/).map(caseWord).join(' '));
    const hasTag = (product, tag) => (Array.isArray(product.tags) ? product.tags.includes(tag) : ` ${product.tags || ''} `.includes(` ${tag} `));

    function rimDisplay(product, sizeValues, finishValues, config, text) {
      const vendor = String(product.vendor || '').trim();
      let brand = vendor;
      if (config.houseVendor && vendor.toLowerCase().includes(config.houseVendor)) brand = config.houseBrands.find((tag) => hasTag(product, tag)) || '';

      let title = String(product.title || '').trim();
      let setOf4 = hasTag(product, 'Set of 4');
      const setAt = title.toLowerCase().indexOf('(set of 4)');
      if (setAt >= 0) { setOf4 = true; title = title.slice(0, setAt).trim(); }

      let diameterPrefix = '';
      const firstWord = title.split(/\s+/)[0] || '';
      const firstNumber = firstWord.replace(/["″]/g, '');
      if (firstNumber !== firstWord && /^[0-9]{2}$/.test(firstNumber)) { diameterPrefix = firstNumber; title = title.slice(firstWord.length).trim(); }

      let fits = '';
      const fitsAt = title.toLowerCase().indexOf(' fits ');
      if (fitsAt >= 0) { fits = title.slice(fitsAt + 6).trim(); title = title.slice(0, fitsAt).trim(); }

      for (const candidate of [brand, vendor, vendor.split(' ')[0]]) {
        if (!candidate) continue;
        const prefix = `${candidate.toLowerCase()} `;
        if (title.toLowerCase().startsWith(prefix)) title = title.slice(prefix.length).trim();
      }
      if (title.toLowerCase().endsWith(' wheels')) {
        const rest = title.slice(0, -7);
        if (hasDigit(rest) && rest.toUpperCase() !== rest.toLowerCase()) title = rest.trim();
      }
      title = titleCase(title);
      if (fits) fits = titleCase(fits);

      const diameters = [];
      let staggered = false;
      let width = '';
      sizeValues.forEach((value) => {
        const valueText = String(value).toLowerCase().trim();
        if (valueText.includes('/')) staggered = true;
        const diameter = valueText.split('x')[0].trim().replace(/"/g, '');
        if (/^[0-9]{2}$/.test(diameter) && +diameter >= 12 && +diameter <= 30 && !diameters.includes(diameter)) diameters.push(diameter);
        if (sizeValues.length === 1 && !staggered) {
          const candidate = String(valueText.split('x')[1] || '').trim().split(/\s+/)[0].replace(/"/g, '');
          width = candidate && /^[0-9.]+$/.test(candidate) ? candidate : '';
        }
      });
      diameters.sort();
      let size = '';
      if (diameters.length === 1) {
        size = width ? `${diameters[0]} × ${width}″` : `${diameters[0]}″${staggered ? ` ${text.staggered}` : ''}`;
      } else if (diameters.length > 1) {
        size = `${diameters[0]}–${diameters[diameters.length - 1]}″`;
      }

      let finish = '';
      if (finishValues.length === 1) finish = titleCase(String(finishValues[0]).trim());
      else if (finishValues.length > 1) finish = text.finishOther.replace('[count]', finishValues.length);

      const check = title.toLowerCase().trim();
      if (!check || check === 'wheels' || check === 'wheel') title = text.generic.replace('[size]', diameterPrefix || diameters[0] || '');
      return { brand, title, fits, setOf4, size, finish };
    }

    class RimFinder extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('.rim-finder__form');
        this.input = this.querySelector('.rim-finder__input');
        this.submit = this.querySelector('.rim-finder__submit');
        this.results = this.querySelector('.rim-finder__results');
        this.status = this.querySelector('[data-rim-status]');
        this.dataElement = this.querySelector('[data-rim-data]');
        this.variantCache = new WeakMap();
        this.cardConfig = {
          houseVendor: String(this.dataset.houseVendor || '').trim().toLowerCase(),
          houseBrands: String(this.dataset.houseBrands || '').split(',').map((tag) => tag.trim()).filter(Boolean)
        };
        this.cardText = {
          generic: this.dataset.cardGeneric || '[size]″',
          staggered: this.dataset.cardStaggered || '',
          finishOther: this.dataset.cardFinishOther || '[count]'
        };
        if (!this.form || !this.input || !this.results || !this.dataElement) return;
        this.products = this.parseData(this.dataElement);
        this.catalogTotal = Number(this.dataElement.dataset.total) || 0;
        this.catalogPageSignatures = new Map();
        this.nextUrl = this.dataElement.dataset.nextUrl || (this.dataset.indexView && Number(this.dataset.catalogPages) > 0 ? this.dataset.collectionUrl : '');
        this.pageCache = new Map();
        this.loadedUrls = new Set();
        this.loadPromise = null;
        this.loadFailed = false;
        this.visibleCount = 24;
        this.searchVersion = 0;
        this.nativeCollection = document.querySelector('collection-component');
        this.originalSubmitText = this.submit.textContent;
        this.handleBrandClick = this.handleBrandClick.bind(this);
        this.handlePopState = this.restoreFromUrl.bind(this);

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.commitSearch({ history: 'push', focus: true });
        });
        this.addEventListener('vehicle-lookup:shop', (event) => this.applyVehicle(event.detail || {}));
        this.addEventListener('vehicle-lookup:clear', () => { if (this.vehicleFilter) this.removeVehicleFilter(false); });
        this.input.addEventListener('input', () => {
          clearTimeout(this.inputTimer);
          this.inputTimer = setTimeout(() => this.commitSearch({ history: 'replace', focus: false }), 220);
        });
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-rim-stock-only]')) this.stockOnly = event.target.checked;
          else if (event.target.matches('[data-rim-sort]')) this.resultSort = event.target.value;
          else return;
          const selector = event.target.matches('[data-rim-sort]') ? '[data-rim-sort]' : '[data-rim-stock-only]';
          this.commitSearch({ history: 'push', focus: false });
          this.results.querySelector(selector)?.focus({ preventScroll: true });
        });
        this.addEventListener('click', (event) => {
          const chip = event.target.closest('[data-rim-query]');
          if (chip) {
            this.input.value = chip.dataset.rimQuery || '';
            this.commitSearch({ history: 'push', focus: true });
          } else if (event.target.closest('[data-rim-more]')) {
            this.visibleCount += 24;
            this.render(false);
          } else if (event.target.closest('[data-rim-clear]')) {
            this.clearSearch(true);
          } else if (event.target.closest('[data-rim-vehicle-remove]')) {
            this.removeVehicleFilter(true);
          } else if (event.target.closest('[data-rim-size]')) {
            this.setQuerySize(event.target.closest('[data-rim-size]').dataset.rimSize);
          }
        });
        document.addEventListener('click', this.handleBrandClick);
        window.addEventListener('popstate', this.handlePopState);
        this.restoreFromUrl();
        requestAnimationFrame(() => { this.updateBrands(); this.setNativeVisibility(this.isActive()); });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleBrandClick);
        window.removeEventListener('popstate', this.handlePopState);
        clearTimeout(this.inputTimer);
      }

      parseData(source) {
        try { const value = JSON.parse(source.textContent || '[]'); return Array.isArray(value) ? value : []; }
        catch (_) { this.loadFailed = true; return []; }
      }

      decodeVariant(raw) {
        if (!Array.isArray(raw)) return raw;
        return { id: raw[0], available: raw[1], price: raw[2], priceValue: raw[3], compareAtPrice: raw[4], compareAtPriceValue: raw[5], image: raw[6], title: raw[7], options: raw[8] || [] };
      }

      isActive() {
        return Boolean(this.parseQuery() || this.vehicleFilter);
      }

      // Called when <vehicle-lookup> asks for wheels that fit. Without a known bolt
      // pattern it falls back to a plain diameter search.
      applyVehicle({ label, bolt, boltLabel, factory }) {
        const key = boltKeys(bolt)[0];
        const size = Number(factory);
        this.vehicleFilter = key ? { key, label: String(label || ''), boltLabel: boltLabel || key, factory: size || null } : null;
        this.input.value = !key && size >= 15 && size <= 24 ? String(size) : '';
        this.commitSearch({ history: 'push', focus: true });
        this.results.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      }

      removeVehicleFilter(focusInput) {
        this.vehicleFilter = null;
        this.commitSearch({ history: 'push', focus: false });
        if (focusInput) this.input.focus({ preventScroll: true });
      }

      setQuerySize(size) {
        const words = normalize(this.input.value).split(' ').filter((word) => word && !/^(1[3-9]|2[0-9]|30)$/.test(word));
        this.input.value = [size, ...words].filter(Boolean).join(' ');
        this.commitSearch({ history: 'replace', focus: false });
        this.results.querySelector(`[data-rim-size="${size}"]`)?.focus({ preventScroll: true });
      }

      buildFitBar(query) {
        const { label, boltLabel, factory } = this.vehicleFilter;
        const fit = element('div', 'rim-finder__fit');
        const head = element('div', 'rim-finder__fit-head');
        const text = element('p', 'rim-finder__fit-label', this.dataset.fits.replace('[vehicle]', label || boltLabel));
        if (label) text.append(element('span', '', boltLabel));
        const remove = element('button', 'rim-finder__fit-remove', '×');
        remove.type = 'button';
        remove.dataset.rimVehicleRemove = '';
        remove.setAttribute('aria-label', this.dataset.removeVehicle);
        head.append(text, remove);
        fit.append(head);
        const sizes = [...new Set(this.findMatches({ ignoreSize: true }).flatMap((match) => match.sizes))].sort((a, b) => a - b);
        if (sizes.length > 1) {
          const group = element('div', 'rim-finder__sizes');
          group.setAttribute('role', 'group');
          group.setAttribute('aria-label', this.dataset.sizesLabel);
          const current = query?.size || null;
          [null, ...sizes].forEach((size) => {
            const chip = element('button', '', size ? `${size}″` : this.dataset.allSizes);
            chip.type = 'button';
            chip.dataset.rimSize = size ? String(size) : '';
            chip.setAttribute('aria-pressed', String(size === current));
            if (size && size === factory) chip.append(element('small', '', this.dataset.factorySize));
            group.append(chip);
          });
          fit.append(group);
        }
        return fit;
      }

      // Decoded variant plus its size/finish/bolt facts, cached per raw variant.
      variantEntry(product, raw) {
        let entry = this.variantCache.get(raw);
        if (!entry) {
          const variant = this.decodeVariant(raw);
          entry = { variant, facts: this.variantFacts(product, variant) };
          if (raw && typeof raw === 'object') this.variantCache.set(raw, entry);
        }
        return entry;
      }
      parseQuery() {
        const raw = normalize(this.input.value);
        if (!raw) return null;
        // Brand names are manufacturer filters, never substring matches in vehicle fitment text.
        const brands = new Set([...document.querySelectorAll('[data-rim-brand-query]')]
          .map((button) => normalize(button.dataset.rimBrandQuery)).filter(Boolean));
        this.products.forEach((product) => { const brand = this.productBrand(product); if (brand) brands.add(brand); });
        const brand = [...brands].sort((a, b) => b.length - a.length)
          .find((name) => (` ${raw} `).includes(` ${name} `)) || null;
        let searchable = ` ${raw} `;
        if (brand) searchable = searchable.replace(` ${brand} `, ' ');
        const sizeMatch = searchable.match(/(?:^|\s)(1[3-9]|2[0-9]|30)(?:\s|$)/);
        const size = sizeMatch ? Number(sizeMatch[1]) : null;
        const colors = Object.keys(colorGroups).filter((color) => colorGroups[color].some((alias) => searchable.includes(` ${normalize(alias)} `)));
        let remainder = searchable;
        if (size) remainder = remainder.replace(new RegExp(`\\s${size}\\s`), ' ');
        colors.forEach((color) => {
          [...colorGroups[color], color].forEach((alias) => { remainder = remainder.replaceAll(` ${normalize(alias)} `, ' '); });
        });
        return { raw, size, colors, brand, terms: normalize(remainder).split(' ').filter(Boolean) };
      }

      productBrand(product) {
        const vendor = normalize(product.vendor);
        if (this.cardConfig.houseVendor && vendor.includes(this.cardConfig.houseVendor)) {
          return normalize(this.cardConfig.houseBrands.find((tag) => hasTag(product, tag)) || '');
        }
        return vendor === 'jnc wheels' ? 'jnc' : vendor;
      }

      variantFacts(product, variant) {
        const sizes = [];
        const bolts = [];
        let hasBoltOption = false;
        const finish = [];
        let hasFinishOption = false;
        (product.optionNames || []).forEach((name, index) => {
          const optionName = normalize(name);
          const value = String((variant.options || [])[index] || '');
          if (optionName.includes('size') || optionName.includes('diameter')) {
            const match = value.match(/(?:^|[^0-9.])(1[3-9]|2[0-9]|30)(?=$|[^0-9.])/);
            if (match) sizes.push(Number(match[1]));
          }
          if (/colou?r|finish/.test(optionName)) { hasFinishOption = true; finish.push(value); }
          if (/bolt|lug|pcd/.test(optionName)) { hasBoltOption = true; bolts.push(...boltKeys(value)); }
        });
        if (!hasBoltOption) bolts.push(...boltKeysInText(`${product.tags || ''} ${product.title || ''} ${variant.title || ''}`));
        const combined = `${product.title || ''} ${variant.title || ''}`;
        const titleMatches = combined.matchAll(/(?:^|[\s(])(1[3-9]|2[0-9]|30)(?=["″]|x[0-9])/gi);
        for (const match of titleMatches) sizes.push(Number(match[1]));
        if (!hasFinishOption) finish.push(product.title, product.tags);
        const colorText = normalize(finish.join(' '));
        const colors = Object.entries(colorGroups).filter(([, aliases]) => aliases.some((alias) => colorText.includes(normalize(alias)))).map(([color]) => color);
        return { sizes: [...new Set(sizes)], colors, bolts: [...new Set(bolts)] };
      }

      findMatches({ ignoreSize = false } = {}) {
        const query = this.parseQuery() || { raw: '', size: null, colors: [], terms: [] };
        const bolt = this.vehicleFilter?.key;
        if (!query.raw && !bolt) return [];
        const size = ignoreSize ? null : query.size;
        const matches = [];
        this.products.forEach((product) => {
          if (query.brand && this.productBrand(product) !== query.brand) return;
          const entries = (product.variants || []).map((raw) => this.variantEntry(product, raw)).filter(({ variant, facts }) => {
            if (this.stockOnly && !variant.available) return false;
            if (bolt && !facts.bolts.includes(bolt)) return false;
            if (size && !facts.sizes.includes(size)) return false;
            if (query.colors.length && !query.colors.every((color) => facts.colors.includes(color))) return false;
            if (!query.terms.length) return true;
            const haystack = normalize([product.title, product.vendor, product.tags, product.url, variant.title, ...(variant.options || [])].join(' '));
            return query.terms.every((term) => haystack.includes(term));
          });
          const variants = entries.map(({ variant }) => variant)
            .sort((a, b) => Number(b.available) - Number(a.available) || a.priceValue - b.priceValue || Number(a.id) - Number(b.id));
          if (variants.length) matches.push({ product, variants, variant: variants[0], sizes: entries.flatMap(({ facts }) => facts.sizes) });
        });
        return matches.sort((a, b) => {
          const aFeatured = /\bf1r\b/i.test(`${a.product.vendor} ${a.product.title}`) ? 1 : 0;
          const bFeatured = /\bf1r\b/i.test(`${b.product.vendor} ${b.product.title}`) ? 1 : 0;
          if (this.resultSort === 'price-ascending') return this.fourTotal(a) - this.fourTotal(b) || a.product.title.localeCompare(b.product.title);
          if (this.resultSort === 'price-descending') return this.fourTotal(b) - this.fourTotal(a) || a.product.title.localeCompare(b.product.title);
          return Number(b.variant.available) - Number(a.variant.available) || bFeatured - aFeatured || a.product.title.localeCompare(b.product.title);
        });
      }

      fourTotal(match) {
        const isSet = hasTag(match.product, 'Set of 4') || /\(set of 4\)/i.test(match.product.title);
        return Number(match.variant.priceValue) * (isSet ? 1 : 4);
      }

      formatTotal(cents) {
        // Shopify money_format preserves presentment-currency symbols and separators.
        const format = this.dataset.moneyFormat;
        if (!format) return (Number(cents) / 100).toFixed(2);
        const token = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
        const noDecimals = token.includes('no_decimals');
        const comma = token.includes('comma_separator');
        const space = token.includes('space_separator');
        const apostrophe = token.includes('apostrophe_separator');
        const parts = (Number(cents) / 100).toFixed(noDecimals ? 0 : 2).split('.');
        const group = space ? ' ' : apostrophe ? "'" : comma ? '.' : ',';
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group);
        const formatted = parts.join(comma || (space && !token.includes('period')) ? ',' : '.');
        const holder = document.createElement('span'); holder.innerHTML = format.replace(/\{\{.*?\}\}/, formatted);
        return holder.textContent;
      }

      buildCard(match) {
        const { product, variant } = match;
        const names = (product.optionNames || []).map((name) => normalize(typeof name === 'string' ? name : name?.name));
        const optionValue = (test) => {
          const index = names.findIndex(test);
          const value = index >= 0 ? (variant.options || [])[index] : '';
          return value ? [String(value)] : [];
        };
        // A result card describes the matched variant, so size and finish are that variant's own.
        const info = rimDisplay(
          product,
          optionValue((name) => name.includes('size') || name.includes('diameter')),
          optionValue((name) => name.includes('finish') || name.includes('color') || name.includes('colour')),
          this.cardConfig,
          this.cardText
        );
        const link = element('a', `rim-finder__card${variant.available ? '' : ' rim-finder__card--sold-out'}`);
        link.href = `${product.url}${String(product.url).includes('?') ? '&' : '?'}variant=${encodeURIComponent(variant.id)}`;
        const media = element('span', 'rim-finder__media');
        const imageUrl = variant.image || product.image;
        if (imageUrl) {
          const image = element('img'); image.src = imageUrl; image.loading = 'lazy'; image.decoding = 'async';
          image.width = 600; image.height = 600;
          try {
            const source = new URL(imageUrl, location.origin);
            if (source.hostname === location.hostname || source.hostname === 'cdn.shopify.com') {
              image.srcset = [320,480,640,960,1200].map(width => { const u = new URL(source); u.searchParams.set('width', width); return `${u.href} ${width}w`; }).join(', ');
              image.sizes = '(min-width: 1200px) 280px, (min-width: 750px) 30vw, calc((100vw - 72px) / 2)';
            }
          } catch (_) {}
          image.alt = [product.title, variant.title && variant.title !== 'Default Title' ? variant.title : ''].filter(Boolean).join(' — ');
          media.append(image);
        }
        const body = element('span', 'rim-card');
        if (info.brand) body.append(element('span', 'rim-card__brand', info.brand));
        body.append(element('span', 'rim-card__title', info.title));
        if (info.size || info.finish) {
          const specs = element('span', 'rim-card__specs');
          [info.size, info.finish].filter(Boolean).forEach((part) => specs.append(element('span', '', part)));
          body.append(specs);
        }
        if (info.fits) body.append(element('span', 'rim-card__fits', this.dataset.cardFits.replace('[vehicles]', info.fits)));
        const price = element('span', 'rim-card__price');
        price.append(element('span', 'rim-card__amount', variant.price));
        if (variant.compareAtPrice) price.append(element('s', 'rim-card__compare', variant.compareAtPrice));
        price.append(element('span', 'rim-card__set', info.setOf4 ? this.dataset.cardSet : this.dataset.cardUnit));
        if (info.setOf4) price.append(element('span', 'rim-card__four', this.dataset.singleEquivalent.replace('[price]', this.formatTotal(Math.round(Number(variant.priceValue) / 4)))));
        const meta = element('span', 'rim-card__meta');
        meta.append(element('span', `rim-card__stock${variant.available ? '' : ' rim-card__stock--out'}`, variant.available ? this.dataset.cardInStock : this.dataset.cardSoldOut));
        const cta = element('span', 'rim-card__cta', this.dataset.cardView);
        cta.setAttribute('aria-hidden', 'true');
        meta.append(cta);
        body.append(price);
        if (!info.setOf4) body.append(element('span', 'rim-card__four', this.dataset.four.replace('[price]', this.formatTotal(this.fourTotal(match)))));
        body.append(meta);
        link.append(media, body);
        return link;
      }

      setNativeVisibility(active) {
        this.nativeCollection ||= document.querySelector('collection-component');
        if (!this.nativeCollection) return;
        this.nativeCollection.hidden = active;
        if (active) this.nativeCollection.setAttribute('inert', ''); else this.nativeCollection.removeAttribute('inert');
      }

      updateBrands() {
        const query = normalize(this.input.value);
        this.querySelectorAll('.rim-finder__chips [data-rim-query]').forEach((chip) => {
          chip.setAttribute('aria-pressed', String(query !== '' && normalize(chip.dataset.rimQuery) === query));
        });
        document.querySelectorAll('[data-rim-brand-query]').forEach((button) => {
          const active = query !== '' && query === normalize(button.dataset.rimBrandQuery);
          button.setAttribute('aria-pressed', String(active));
          if (active) button.scrollIntoView({ block: 'nearest', inline: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      }

      render(announce = false) {
        const query = this.parseQuery();
        this.results.replaceChildren();
        if (!query && !this.vehicleFilter) { this.results.hidden = true; this.status.textContent = ''; this.setNativeVisibility(false); return; }
        this.setNativeVisibility(true); this.results.hidden = false;
        if (this.vehicleFilter) this.results.append(this.buildFitBar(query));
        const loading = Boolean(this.nextUrl) && !this.loadFailed;
        const matches = this.findMatches();
        const bar = element('div', 'rim-finder__result-bar');
        const summary = element('p', 'rim-finder__summary', loading ? this.dataset.loading : this.loadFailed ? this.dataset.loadError : this.dataset.results.replace('[count]', matches.length));
        summary.tabIndex = -1; summary.dataset.rimSummary = '';
        const clear = element('button', 'rim-finder__clear', this.dataset.clear); clear.type = 'button'; clear.dataset.rimClear = '';
        bar.append(summary, clear); this.results.append(bar);
        const tools = element('div', 'rim-finder__shopping-tools');
        const stockLabel = element('label', '');
        const stock = element('input'); stock.type = 'checkbox'; stock.dataset.rimStockOnly = ''; stock.checked = Boolean(this.stockOnly);
        stockLabel.append(stock, document.createTextNode(this.dataset.stockOnly));
        const sortLabel = element('label', '', this.dataset.sortLabel);
        const sort = element('select'); sort.dataset.rimSort = ''; sort.setAttribute('aria-label', this.dataset.sortLabel);
        [['featured', this.dataset.sortFeatured], ['price-ascending', this.dataset.sortLow], ['price-descending', this.dataset.sortHigh]].forEach(([value, label]) => {
          const option = element('option', '', label); option.value = value; sort.append(option);
        });
        sort.value = this.resultSort || 'featured'; sortLabel.append(sort); tools.append(stockLabel, sortLabel);
        this.results.append(tools, element('p', 'rim-finder__estimate-note', this.dataset.estimateNote));
        matches.slice(0, this.visibleCount).forEach((match) => this.results.append(this.buildCard(match)));
        const noResults = this.vehicleFilter ? this.dataset.vehicleNoResults.replace('[bolt]', this.vehicleFilter.boltLabel) : this.dataset.noResults;
        if (!loading && !matches.length) this.results.append(element('p', 'rim-finder__message', this.loadFailed ? this.dataset.loadError : noResults));
        else if (this.loadFailed) this.results.append(element('p', 'rim-finder__message', this.dataset.loadError));
        if (!loading && matches.length > this.visibleCount) {
          const wrap = element('div', 'rim-finder__more-wrap');
          const more = element('button', 'rim-finder__more', this.dataset.showMore.replace('[count]', matches.length - this.visibleCount));
          more.type = 'button'; more.dataset.rimMore = ''; wrap.append(more); this.results.append(wrap);
        }
        if (!loading && !matches.length) {
          const help = element('a', 'rim-finder__help-link', this.dataset.helpEmpty);
          const localizedRoot = this.dataset.collectionUrl.split('/collections/')[0];
          help.href = `${localizedRoot}/pages/contact?product=Wheel%20fitment#product-inquiry`; this.results.append(help);
        }
        this.results.setAttribute('aria-busy', String(loading));
        this.status.textContent = loading ? this.dataset.loading : this.loadFailed ? this.dataset.loadError : this.dataset.results.replace('[count]', matches.length);
        if (this.pendingFocus && !loading) { summary.focus({ preventScroll: true }); this.pendingFocus = false; }
      }

      async loadRemaining() {
        if (!this.nextUrl || this.loadPromise) return this.loadPromise;
        this.loadFailed = false; this.submit.disabled = true; this.submit.textContent = this.dataset.loadingShort;
        this.loadPromise = (async () => {
          try {
            const pages = Number(this.dataset.catalogPages);
            if (this.dataset.indexView && Number.isInteger(pages) && pages > 0) {
              // A data-only view avoids downloading the full section's markup on each page.
              // Limit parallelism to three requests; include page 1 so search also works when
              // opened from native pagination or an availability/price-filtered collection.
              let nextPage = 1;
              let failed = false;
              const consume = async () => {
                while (nextPage <= pages) {
                  const page = nextPage++;
                  const url = new URL(this.dataset.collectionUrl, location.origin);
                  if (url.origin !== location.origin) throw new Error('Invalid collection');
                  url.search = new URLSearchParams({ view: this.dataset.indexView, page: String(page) });
                  try {
                    let payload = this.pageCache.get(url.href);
                    if (!payload) {
                      const controller = new AbortController();
                      const timer = setTimeout(() => controller.abort(), 15000);
                      try {
                        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } });
                        if (!response.ok) throw new Error('Catalog unavailable');
                        const data = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-rim-data]');
                        if (!data) throw new Error('Catalog data missing');
                        const products = JSON.parse(data.textContent);
                        if (!Array.isArray(products)) throw new Error('Invalid catalog data');
                        const reportedPage = Number(data.dataset.page);
                        const total = Number(data.dataset.total);
                        if (reportedPage && reportedPage !== page) throw new Error('Wrong catalog page');
                        if (total > 0 && products.length === 0) throw new Error('Empty catalog page');
                        if (total > 0) {
                          if (this.catalogTotal && this.catalogTotal !== total) throw new Error('Catalog changed during loading');
                          this.catalogTotal = total;
                        }
                        if (products.some((product) => !product.id || !Array.isArray(product.variants))) throw new Error('Invalid product');
                        const signature = JSON.stringify(products.map((product) => String(product.id)).sort());
                        if (products.length && [...this.catalogPageSignatures].some(([number, known]) => number !== page && known === signature)) throw new Error('Repeated catalog page');
                        this.catalogPageSignatures.set(page, signature);
                        payload = { products };
                        this.pageCache.set(url.href, payload);
                      } finally { clearTimeout(timer); }
                    }
                    const known = new Set(this.products.map((product) => String(product.id)));
                    payload.products.forEach((product) => { if (!known.has(String(product.id))) { this.products.push(product); known.add(String(product.id)); } });
                    this.render(false);
                  } catch (_) { failed = true; }
                }
              };
              await Promise.all(Array.from({ length: Math.min(3, pages) }, consume));
              if (failed || (this.catalogTotal && this.products.length !== this.catalogTotal)) throw new Error('Catalog incomplete');
              this.nextUrl = '';
              return;
            }
            while (this.nextUrl) {
              const pageUrl = new URL(this.nextUrl, location.href);
              if (pageUrl.origin !== location.origin || this.loadedUrls.has(pageUrl.href)) throw new Error('Invalid pagination');
              const cacheKey = pageUrl.href;
              let payload = this.pageCache.get(cacheKey);
              if (!payload) {
                const requestUrl = new URL(pageUrl); requestUrl.searchParams.set('section_id', this.dataset.sectionId);
                const controller = new AbortController(); const timer = setTimeout(() => controller.abort(), 15000);
                try {
                  const response = await fetch(requestUrl, { signal: controller.signal, headers: { Accept: 'text/html' } });
                  if (!response.ok) throw new Error('Catalog unavailable');
                  const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
                  const data = doc.querySelector('[data-rim-data]');
                  if (!data) throw new Error('Catalog data missing');
                  payload = { products: this.parseData(data), nextUrl: data.dataset.nextUrl || '' }; this.pageCache.set(cacheKey, payload);
                } finally { clearTimeout(timer); }
              }
              const known = new Set(this.products.map((product) => String(product.id)));
              payload.products.forEach((product) => { if (!known.has(String(product.id))) { this.products.push(product); known.add(String(product.id)); } });
              this.loadedUrls.add(cacheKey); this.nextUrl = payload.nextUrl; this.render(false);
            }
          } catch (_) { this.loadFailed = true; }
          finally { this.loadPromise = null; this.submit.disabled = false; this.submit.textContent = this.originalSubmitText; this.render(true); }
        })();
        return this.loadPromise;
      }

      updateUrl(mode) {
        if (!/^https?:$/.test(location.protocol)) return;
        const url = new URL(location.href); const query = this.input.value.trim();
        if (query) url.searchParams.set('rim_q', query); else url.searchParams.delete('rim_q');
        if (this.stockOnly) url.searchParams.set('rim_stock', '1'); else url.searchParams.delete('rim_stock');
        if (this.resultSort && this.resultSort !== 'featured') url.searchParams.set('rim_sort', this.resultSort); else url.searchParams.delete('rim_sort');
        const vehicle = this.vehicleFilter;
        [['rim_bolt', vehicle?.key], ['rim_vehicle', vehicle?.label], ['rim_factory', vehicle?.factory]].forEach(([name, value]) => {
          if (value) url.searchParams.set(name, String(value)); else url.searchParams.delete(name);
        });
        history[mode === 'push' ? 'pushState' : 'replaceState']({ rimQuery: query }, '', url);
      }

      commitSearch({ history: historyMode, focus }) {
        this.visibleCount = 24; this.searchVersion += 1; this.pendingFocus = Boolean(focus);
        this.updateUrl(historyMode); this.updateBrands(); this.render(false);
        if (this.isActive()) this.loadRemaining();
      }

      clearSearch(pushHistory) {
        this.input.value = ''; this.vehicleFilter = null; this.stockOnly = false; this.resultSort = 'featured'; this.pendingFocus = false; this.searchVersion += 1;
        this.updateUrl(pushHistory ? 'push' : 'replace'); this.updateBrands(); this.render(false);
        this.input.focus({ preventScroll: true });
      }

      restoreFromUrl() {
        const params = new URL(location.href).searchParams;
        this.input.value = params.get('rim_q') || '';
        this.stockOnly = params.get('rim_stock') === '1';
        this.resultSort = ['price-ascending','price-descending'].includes(params.get('rim_sort')) ? params.get('rim_sort') : 'featured';
        const key = boltKeys(params.get('rim_bolt'))[0];
        this.vehicleFilter = key ? {
          key, label: String(params.get('rim_vehicle') || '').slice(0, 80), boltLabel: key.replace('x', '×'), factory: Number(params.get('rim_factory')) || null
        } : null;
        this.visibleCount = 24; this.pendingFocus = false; this.updateBrands(); this.render(false);
        if (this.isActive()) this.loadRemaining();
      }

      handleBrandClick(event) {
        const button = event.target.closest('[data-rim-brand-query]');
        if (!button) return;
        const brand = button.dataset.rimBrandQuery || '';
        this.input.value = normalize(this.input.value) === normalize(brand) ? '' : brand;
        this.commitSearch({ history: 'push', focus: true });
        this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    }
    customElements.define('rim-finder', RimFinder);
  })();

  } catch(e) { console.error(e); }
})();
})();
